import CountUp from "react-countup";
import { Rings } from "./decor";
import { FOUNDER_STATS } from "../data";
import { Reveal, SectionLabel } from "./primitives";

const FOUNDER_IMG = "/vicky.jpg";

export const Founder = () => (
  <section id="about" data-testid="founder-section" className="relative isolate overflow-hidden bg-white py-24 md:py-32">
    <Rings className="bottom-[-30px] right-[-30px] h-72 w-72 opacity-70" />
    <div className="mx-auto max-w-7xl px-6 md:px-8">
      <div className="grid gap-14 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20">
        <Reveal>
          <div className="relative">
            {/* Founder photo — Vicky Thorat */}
            <div className="relative overflow-hidden rounded-2xl border border-line">
              <img src={FOUNDER_IMG} alt="Vicky Thorat, Founder of XSELL Solutions" className="aspect-[4/5] h-full w-full object-cover object-top" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent" />
            </div>
          </div>
        </Reveal>

        <div>
          <Reveal>
            <SectionLabel>The Founder</SectionLabel>
            <h2 className="mt-4 font-serif text-3xl font-medium tracking-tight text-[#23271F] sm:text-4xl lg:text-5xl">
              Vicky Thorat
            </h2>
            <p className="mt-2 text-[#5C8A1E]">Senior Sales & Revenue Growth Professional · 18+ Years</p>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="mt-6 space-y-4 text-sm leading-relaxed text-[#4c5445] sm:text-base">
              <p>
                Eighteen-plus years of hands-on sales leadership and GTM strategy across Technology,
                IT Services and Digital Services — spanning Head of Global Sales, VP – Sales &
                Strategic Accounts, and senior business leadership roles across North America, APAC,
                EMEA and ROW.
              </p>
              <p>
                A seasoned sales and revenue leader with expertise in Go-to-Market strategy,
                enterprise sales, and commercial growth across Technology Services, SaaS &amp;
                Software Products, Business Services, and Learning &amp; Technology solutions.
                Proven ability to build revenue engines, acquire and grow strategic enterprise
                accounts, expand into new markets, and transform sales organizations for
                sustainable growth. Combines strategic leadership with a strong focus on
                execution, client value, and data-driven decision-making, increasingly powered
                by AI-enabled RevOps and intelligent sales technologies.
              </p>
            </div>
          </Reveal>

          <div className="mt-10 grid grid-cols-3 gap-4 sm:gap-6">
            {FOUNDER_STATS.map((s, i) => (
              <Reveal key={i} delay={i * 0.08}>
                <div data-testid={`stat-${i}`} className="border-l border-line pl-4">
                  <p className="font-serif text-3xl font-semibold text-[#5C8A1E] sm:text-4xl">
                    {s.prefix || ""}
                    <CountUp end={s.value} duration={2} enableScrollSpy scrollSpyOnce />
                    {s.suffix}
                  </p>
                  <p className="mt-1 text-xs leading-snug text-[#5f6857]">{s.label}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
